import { Type, type Static } from "@sinclair/typebox";
import { UuidSchema } from "./identifiers.ts";
import { MatrixUserIdSchema } from "./registered-agent.ts";

export const ROOM_FILE_ACTIVITY_EVENT_TYPE = "io.matrix_idp.room.file_activity" as const;

export const RoomFileActivityOperationSchema = Type.Union([
  Type.Literal("uploaded"),
  Type.Literal("created"),
  Type.Literal("updated"),
  Type.Literal("moved"),
  Type.Literal("deleted")
]);
export type RoomFileActivityOperationV1 = Static<typeof RoomFileActivityOperationSchema>;

export const RoomFileActivitySchema = Type.Object(
  {
    version: Type.Literal("1.0"),
    activityId: UuidSchema,
    fileSpaceId: UuidSchema,
    openCloudResourceId: Type.String({ minLength: 1, maxLength: 1_024 }),
    operation: RoomFileActivityOperationSchema,
    entryKind: Type.Union([Type.Literal("file"), Type.Literal("folder")]),
    name: Type.String({ minLength: 1, maxLength: 512 }),
    path: Type.String({ minLength: 1, maxLength: 4_096 }),
    previousPath: Type.Optional(Type.String({ minLength: 1, maxLength: 4_096 })),
    actorMxid: Type.Optional(MatrixUserIdSchema),
    occurredAt: Type.String({
      pattern: "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(?:\\.\\d{3})?Z$"
    })
  },
  { additionalProperties: false }
);
export type RoomFileActivityV1 = Static<typeof RoomFileActivitySchema>;
